export * from './NewsModuleCardFeature';
